import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../../services/faq.service';
import {ActivatedRoute} from '@angular/router';
import {FaqArticle} from '../../../model/faq-article';
import { Location } from '@angular/common';
import {FaqCategoryService} from '../../../services/faq-category.service';
import {FaqCategory} from '../../../model/FaqCategory';
import {Label} from '../../../model/Label';
import {ToastrService} from 'ngx-toastr';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {FaqArticleDisplayComponent} from "../../../components/common/faq-article-display/faq-article-display.component";
import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {UrlDecodePipe} from "../../../components/common/UrlDecodePipe";
import {SpinnerComponent} from "../../../components/common/spinner/spinner.component";

@Component({
    selector: 'app-faq-article',
    imports: [
    FaIconComponent,
    BadgeComponent,
    FaqArticleDisplayComponent,
    SpinnerComponent,
    BreadcrumbComponent,
    UrlDecodePipe
],
    templateUrl: './faq-article.component.html',
    styleUrls: ['./faq-article.component.css']
})
export class FaqArticleComponent implements OnInit {

  article: FaqArticle;
  categories: FaqCategory[];

  constructor(private faqService: FaqService,
              private faqCategoryService: FaqCategoryService,
              private route: ActivatedRoute,
              private location: Location,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.faqCategoryService.getObjects().subscribe(categories => {
      this.categories = categories;
    });
    this.faqService.getObjects().subscribe(data => {
      this.article = data.find(d => d.id.toString() === id);
    });
  }

  goBack(): void {
    this.location.back();
  }

  getLabelFromCategoryId(id: number): Label {
    const cat = this.categories.find(c => +c.categoryId === id);
    if (cat !== undefined) {
      return {id: cat.id, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name};
    } else {
      return undefined;
    }
  }

  copyPublicLink(): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (window.location.href.replace('/faq/', '/public/')));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    this.toastr.success('Lien public copié dans le presse-papier');
  }


}
